// Hooks / Node modules / Styles

// Reducers / Actions

// Utils / Functions

// Components
import DefaultLayout from "src/layout/standard/primary/DefaultLayout";
import TitleBar from "src/components/base/title-bar/TitleBar";

// Sub-Components
import GameCardGroup from "./com/GameCardGroup";

// Data / Images / Icons

function P_Game() {
  return (
    <DefaultLayout>
      <TitleBar />

      <GameCardGroup/>
    </DefaultLayout>
  )
}

export default P_Game